import { useReducer } from "react";
import { Filters } from "../../../Utils/Filters/types";

export type InsuranceFormFields =
  | "submitted"
  | "filters"
  | "date"
  | "referenceFiles"
  | "caseNumber"
  | "ssn"
  | "notes";

export interface InsuranceFormState {
  submitted: boolean
  filters?: Filters,
  date?: Date,
  referenceFiles: File[],
  caseNumber?: number,
  ssn?: number,
  notes?: string,
};

interface InsuranceFormAction {
  type: "update" | "clear",
  field: InsuranceFormFields
  payload?: any;
}

const reducer = (state: InsuranceFormState, action: InsuranceFormAction) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.payload,
      };
    case "clear":
      return {
        ...state,
        [action.field]: {},
      };
    default:
      return state;
  }
};

export const useInsuranceForm = () => {
  const [state, dispatch] = useReducer(reducer, {
    submitted: false,
    referenceFiles: []
  });

  return { state, dispatch };
};
